import React from 'react';
import { HttpError } from '../../components';
import { withTranslation } from 'react-i18next';
import { NAMESPACES } from '../../i18n';

const PortletError = ({ t }) => <HttpError message={t('portlet_403_error')} />;

export default withTranslation(NAMESPACES.common)(PortletError);
